import Axios, { AxiosInstance } from "axios";

export const client: AxiosInstance = Axios.create({
  baseURL: "https://redx-ng-api.adamski2003.lol",
  headers: {
    "Content-Type": "application/json",
  },
  // paramsSerializer: (params) => new URLSearchParams(params).toString(),
});
